import React, {useCallback} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import {connect} from "react-redux";
import Title from "features/components/title";
import {__} from "services/i18n";
import Button from "features/components/button";
import Text from "features/components/text";
import {
    threadArchiveErrorSelector,
    threadArchiveLoadingSelector,
    threadArchiveShowModal
} from "features/modals/thread-archive/selectors";
import {threadArchiveSetShow, threadArchiveStart} from "features/modals/thread-archive/reducer";
/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: threadArchiveLoadingSelector(state),
    error: threadArchiveErrorSelector(state),
    should_show: threadArchiveShowModal(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    threadArchiveSetShow,
    threadArchiveStart
};

export const ThreadArchiveModal = (props) => {

    const {threadArchiveStart, threadArchiveSetShow} = props;
    const {loading, error, id, should_show} = props;

    const doArchive = useCallback(() => {
        threadArchiveStart(id);
    }, [threadArchiveStart, id]);

    const doCancel = useCallback(() => {
        threadArchiveSetShow(false)
    }, [threadArchiveSetShow]);

    if (!should_show) return null;

    return <ModalPortal className={"thread-archive-modal"}>
        <Title size={34}>{__("modal.thread-archive.title")}</Title>
        <Text size={16}>{__("modal.thread-archive.text")}</Text>
        <Button title={__("modal.thread-archive.button")} onClick={doArchive} type={"accent"} icon={"archive"} status={loading ? "loading" : ""} />
        <Button title={__("buttons.cancel")} onClick={doCancel} type={"outlined"} />
        {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
    </ModalPortal>
}

export default connect(mapStateToProps, mapDispatchToProps)(ThreadArchiveModal);